<script lang="ts">
  import Label from '$provider/constants/Label';
  import type { AlertDetailedInfo } from '$shared/models/AlertDetailedInfo';

  interface Props {
    data: AlertDetailedInfo;
    children?: import('svelte').Snippet;
  }

  let { data, children }: Props = $props();

  let showDetails = $state(false);

  let actionLabel = $derived(showDetails ? Label.HideDetails : Label.Details);

  const onClickToggleDetails = () => {
    showDetails = !showDetails;
  };
</script>

<div class="detail-container">
  <div class="detail-alert">
    {#if data}
      <div class="title">
        <div class="text" data-cy="alert-text">{data.title}</div>
        {#if data?.hasDetails}
          <button
            type="button"
            class="toggle-button"
            data-cy="alert-detail"
            onclick={onClickToggleDetails}
          >
            {actionLabel}
          </button>
        {/if}
      </div>
    {/if}
    {@render children?.()}
    {#if data?.hasDetails}
      <div class="details" class:show={showDetails}>
        {#each data?.messages as message, index}
          <div class="message" data-cy={`alert-message-${index}`}>{message}</div>
        {/each}
      </div>
    {/if}
  </div>
</div>

<style>
  .detail-container {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .detail-alert {
    width: inherit;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .title {
    font-size: 14px;
    line-height: 22px;
    display: inline-flex;
  }
  .title .toggle-button {
    margin-left: 4px;
    font-size: 14px;
    line-height: 22px;
    color: inherit;
    text-decoration: underline;
  }
  .details {
    margin-top: 4px;
    display: none;
  }
  .details.show {
    display: block;
  }
  .details .message {
    margin-bottom: 4px;
    line-height: 22px;
    font-size: 14px;
  }
  .details .message::before {
    content: '•';
    margin-right: 8px;
  }
</style>
